import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Table } from "react-bootstrap";
import { FaDownload } from 'react-icons/fa';
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import { CustomerServices } from '../../services/CustomerServices';
import { customStyles, the } from "../components/customStyles";
import From from '../components/From';
import "../custom.css";
import NumberFormatter from "../components/NumberFormatter";
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import * as BullCache from "../../util/BullCache";

function Account() {

    const [fromDate, setFromDate] = useState('');
    const [type, setType] = useState('');
    const [balance, setBalance] = useState('');
    const [name, setName] = useState('');
    const [totalDeposit, setTotalDeposit] = useState('');
    const [transactionList, setTransactionList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);

    const userId = searchParams.get('userid'); 
    const adminId = searchParams.get('adminId'); 
    var user = BullCache.getFromCache("user");

    const handleFromDateChange = (newDate) => {
        if(newDate){ 
            setFromDate(newDate);
        } else{
            setFromDate('');
        }
    };
    
    useEffect(() => {
        findLogs(false);
    }, []);

    const downloadPDF = (transaction) => {
        if(userId) {
            navigate("/usersummary", { state: { userId: userId, valan: transaction.valanId} });  
        } else if(adminId) {
            navigate("/mastersummary", { state: { adminId: adminId, valan: transaction.valanId} });  
        }
    };

    const handleTypeChange = (newType) => {
        if(newType){ 
            setType(newType.value);
        } else{
            setType('');
        }
    };
    
    const findLogs = (sendDate) => {
        if(userId) {
            CustomerServices.getAccount({ 'userId': userId, 'loginId': user.adminId,  date: sendDate ? fromDate : '', status: type }).then(resp => {
                if (resp.code === 1) {
                    const transactionList = resp.data.account.transactionList;
                    setBalance(resp.data.account.balance);
                    setName(resp.data.account.userName);
                    setTotalDeposit(resp.data.account.totalDeposit);
                    setTransactionList(transactionList);
                }
            });
        } else if(adminId){
         CustomerServices.getAdminAccount({loginId: user.adminId, 'adminId': adminId,  date: sendDate ? fromDate : '', status: type  }).then(resp => {
            if (resp.code === 1) {
                const transactionList = resp.data.account.transactionList;
                setBalance(resp.data.account.balance);
                setName(resp.data.account.userName);
                setTotalDeposit(resp.data.account.totalDeposit);
                setTransactionList(transactionList);
            }
        });
    }
    };

    return (
        <div className='container-fluid mb-5'>

            <Row>
                <Col xl={12} className='text-center mt-1'><h6>Ledger User Wise: {name}</h6></Col>
            </Row>

            <Card className="mt-1">
                <Card.Body>
                    <Row>
                        <Col xl={1} xs={4} md={2}>
                            <b className='fss-05'>FROM DATE</b><br />
                            <From fromDate={fromDate} onDateChange={(selectedDate) => handleFromDateChange(selectedDate)} />
                        </Col>
                        <Col xl={2} xs={6} md={4} className='pe-0'>
                            <b className='fss-05 h6'> ENTRY TYPE </b> <br />
                            <Select
                                options={[
                                    { value: 'Both', label: 'Both' },
                                    { value: 'Cash Entry', label: 'Cash Entry' },
                                    { value: 'Bill Entry', label: 'Bill Entry' }
                                ]}
                                className='text-black ps-0'
                                placeholder="Select"
                                styles={customStyles}
                                theme={the} 
                                onChange={(selectedOption) => handleTypeChange(selectedOption)}
                                isClearable
                            />
                        </Col>
                        <Col className='mt-4' xl={1} xs={1} md={1}>
                            <Button size='sm' variant='success' className='text-light ms-0' onClick={() => findLogs(true)}>Logs</Button>
                        </Col>
                        <Col xl={2} md={2} className='mt-2'>
                            <Card className="w-auto summary-card">
                                <Card.Body className="pt-1 p-0">
                                <Row className="m-0">
                                    <Col
                                    className="text-center fss-08"
                                    style={{ whiteSpace: "nowrap" }}
                                    >
                                    TOTAL DEPOSIT
                                    <br />
                                    <NumberFormatter number={totalDeposit ?? 0}></NumberFormatter>
                                    </Col>
                                </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
            <Card className="mt-1 mb-5">
                <Card.Body className="p-1 mb-5">

                    <div className="table-responsive mt-2" >
                    <Table bordered className="fss-08"  style={{ width: "100%" }}>
                        <thead className="bg-head-secondary">
                            <tr>
                            <th style={{ minWidth: "60px" }}>SR NO</th>
                            <th style={{ minWidth: "150px" }}>REMARK</th>
                            <th style={{ minWidth: "120px" }}>DATE</th>
                            <th style={{ minWidth: "120px" }}>DEBIT</th>
                            <th style={{ minWidth: "120px" }}>CREDIT</th>
                            <th style={{ minWidth: "150px" }}>BALANCE</th>
                                
                            </tr>
                        </thead>
                            
                            <tbody className="font-bold">
                                {transactionList.length === 0 ?
                                    <tr>
                                        <td colSpan="7" className="text-center">No data available</td>
                                    </tr>
                                    :
                                    transactionList.map((tr, index) => {
                                        return (
                                            <tr className='highlight-row'>
                                                <td  className='pt-1 pb-1'>{index + 1}</td>
                                                <td className=' pt-1 pb-1'>{tr.valan} &nbsp; { tr.billEntry ?
                                                    <Button
                                                        variant="outline-success"
                                                        size="sm"
                                                        className='ms-1 mt-0 pt-0 pb-0 text-center'
                                                        onClick={() => downloadPDF(tr)}
                                                    >
                                                        <FaDownload size={12} className='pt-0' />
                                                    </Button>
                                                     : ""}
                                                </td>
                                                <td  className='pt-1 pb-1'> {moment(tr.date, 'YYYY-MM-DD').format('DD-MM-YYYY')}</td>
                                                <td  className='pt-1 pb-1'>{tr.amount < 0 ? <NumberFormatter number={tr.amount}/> : ''}</td>
                                                <td  className='pt-1 pb-1'>{tr.amount > 0 ?  <NumberFormatter number={tr.amount} /> : ''}</td>
                                                <td  className='pt-1 pb-1'><NumberFormatter number={tr.balance || 0}/></td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                            <tfoot className="font-bold">
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td> <div className='d-flex text-right fss-1 positive-amout-color'>TOTAL:&nbsp;<NumberFormatter number={balance}/></div></td>
                                </tr>
                            </tfoot>
                        </Table>
                        </div>
                </Card.Body>
            </Card>
        </div>
    );
}
export default Account;
